export const itemCheckStates = {
  CHECKED: 'CHECKED',
  INDETERMINATE: 'INDETERMINATE',
  UNCHECKED: 'UNCHECKED',
};

export const flatRowTypes = {
  DIVIDER: 'divider',
  GROUP_LABEL: 'group-label',
  ITEM: 'item',
};

export const sizes = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
};

export const INDENT_PX = 16;

export const SELECT_ALL_ID = 'select-all-id';
